import {
  Users,
  UserSearch,
  Inbox,
  BedDouble,
  Sparkles,
  FolderOpen,
  BadgeCheck,
  Filter,
  Megaphone,
  MessagesSquare,
} from "lucide-react";

export const TROVA_OSPITI_CONFIG = {
  servizio: "ospiti",
  path: "/trova-ospiti",
  title: "Trova Ospiti",
  welcomeTitle: "Benvenuto in Trova Ospiti",
  subtitle: "Richieste da famiglie, partner e strutture in cerca di posto.",
  tagline: "Un grande network, un unico obiettivo: trovare la soluzione giusta per ogni ospite.",
  description:
    "Stiamo costruendo il più grande network italiano dedicato alle strutture socio-assistenziali. Questa area è in fase di sviluppo e sarà attivata progressivamente con nuove funzionalità.",
  icon: Users,
  theme: "ospiti",
  badgeLabel: "BETA",
  illustrationSrc: "/images/trova-ospiti-illustration.png",
  illustrationAlt: "Illustrazione Trova Ospiti: profili e struttura",
  illustrationCaption:
    "Insieme siamo più forti — Più siamo, più opportunità possiamo offrire alle famiglie e alle strutture.",
  benefits: [
    {
      icon: Inbox,
      title: "Ricevi richieste qualificate",
      text: "Richieste da famiglie, partner e strutture.",
    },
    {
      icon: BedDouble,
      title: "Condividi i tuoi posti disponibili",
      text: "Fai conoscere i tuoi posti letto in pochi click.",
    },
    {
      icon: Sparkles,
      title: "Matching intelligente",
      text: "Il sistema abbina le richieste più compatibili con la tua struttura.",
    },
    {
      icon: FolderOpen,
      title: "Gestisci tutto in un unico posto",
      text: "Storico, documenti e comunicazioni sempre a portata di mano.",
    },
  ],
  stats: [
    { value: "14", label: "Richieste disponibili", hint: "+3 nuove oggi" },
    { value: "6", label: "Compatibili con te", hint: "90% o più" },
    { value: "3", label: "Urgenti", hint: "entro 7 giorni" },
    { value: "11", label: "Da partner in rete", hint: "scuole e strutture" },
    { value: "250 €", label: "Gettoni maturati", hint: "questo mese" },
  ],
  previewRows: [
    { name: "Mario Rossi", meta: "82 anni · Alzheimer · Roma", score: 93, badge: "Urgente" },
    { name: "Anna Bianchi", meta: "76 anni · Autonomia ridotta · RM", score: 88, badge: "Nuova" },
    { name: "Giuseppe Verdi", meta: "89 anni · Post-acuto · Lazio", score: 81, badge: "Partner" },
  ],
  richiestaPlaceholder:
    "Es. Cerchiamo un ospite donna per posto letto in camera doppia, ingresso entro settembre…",
  ctaHint: "Sarai tra i primi a provarlo",
};

export const TROVA_PERSONALE_CONFIG = {
  servizio: "personale",
  path: "/trova-personale",
  title: "Trova Personale",
  welcomeTitle: "Benvenuto in Trova Personale!",
  subtitle: "Trova OSS, infermieri, educatori e altri professionisti per la tua struttura.",
  tagline: null,
  description:
    "Stiamo costruendo la rete italiana di professionisti socio-sanitari per aiutare le strutture a trovare il personale giusto, più velocemente.",
  icon: UserSearch,
  theme: "personale",
  badgeLabel: "BETA IN SVILUPPO",
  illustrationSrc: "/images/trova-personale-illustration.svg",
  illustrationAlt: "Illustrazione Trova Personale: ricerca professionisti",
  illustrationCaption: null,
  benefits: [
    {
      icon: BadgeCheck,
      title: "Accedi a professionisti verificati",
      text: "Candidati con documenti e competenze controllate.",
    },
    {
      icon: Filter,
      title: "Trova il profilo giusto per le tue esigenze",
      text: "Filtra per ruolo, esperienza, zona e disponibilità.",
    },
    {
      icon: Megaphone,
      title: "Pubblica le tue richieste di personale",
      text: "Ricevi candidature mirate in tempi rapidi.",
    },
    {
      icon: MessagesSquare,
      title: "Gestisci tutto in un unico posto",
      text: "Comunicazioni, selezioni e conferme semplificate.",
    },
  ],
  stats: [
    { value: "18", label: "Professionisti disponibili", hint: "+4 nuovi oggi" },
    { value: "7", label: "Compatibili con te", hint: "90% o più" },
    { value: "3", label: "Disponibili da subito", hint: "entro 72 ore" },
    { value: "6", label: "Da scuole / partner", hint: "in formazione" },
    { value: "0", label: "Preferiti salvati", hint: "—" },
  ],
  previewRows: [
    { name: "Laura Santini", meta: "OSS · Guidonia Montecelio (RM)", score: 95, badge: "Nuovo" },
    { name: "Marco Ferretti", meta: "Infermiere · Roma", score: 91, badge: "Subito" },
    { name: "Elena Conti", meta: "Educatrice · Tivoli (RM)", score: 87, badge: "Partner" },
  ],
  richiestaPlaceholder:
    "Es. Cerchiamo un/una OSS full time per turni di mattina, con esperienza anziani…",
  ctaHint: "Sarai tra i primi a provarlo",
};
